import { ContinuousScaleAnswerFormat, ScaleAnswerFormat } from "../../../../types/Survey";

export function createHelpers(answerFormat: ScaleAnswerFormat) {
    function getMaximumFractionDigits(): number {
        if (answerFormat.type == "ScaleAnswerFormat") { return 0; }
        let continousScaleAnswerFormat = answerFormat as ContinuousScaleAnswerFormat;
        var fractionDigits = continousScaleAnswerFormat.maximumFractionDigits || 0;
        if (fractionDigits < 0) { return 0; }
        if (fractionDigits > 4) { return 4; }
        return fractionDigits;
    }

    function formatValue(value: string): string | null {
        return formatValueToDigits(value, getMaximumFractionDigits());
    }


    function formatValueToDigits(value: string, maximumFractionDigits: number): string | null {
        if (isNaN(parseFloat(value))) {
            return null;
        }

        if (answerFormat.type == "ScaleAnswerFormat") {
            return parseInt(value).toFixed(0);
        }

        //extra parseFloat ensures we trim trailing 0s
        return parseFloat(parseFloat(value).toFixed(maximumFractionDigits)).toString();
    }

    function getMinimumStepValue() {
        const maximumFractionDigits = getMaximumFractionDigits();
        return maximumFractionDigits ? Math.pow(10, -maximumFractionDigits) : 1;
    }

    return {
        getMinimumStepValue,
        getMaximumFractionDigits,
        formatValue,
        formatValueToDigits
    }
}
